import { HeroModal } from "./HeroModal"

export const HERO_MODALS = {
  hero: {
    component: HeroModal
  }
} as const
